import { BaseStrapi, GraphSchema, baseStrapiProps } from '@camelot/server';

export interface DynamicTranslation extends BaseStrapi {
  key: string;
  value: string;
}

const props: (keyof DynamicTranslation)[] = ['key', 'value'];

export const dynamicTranslationProps = new GraphSchema<DynamicTranslation>(props.concat(baseStrapiProps));
